// @flow
import React from 'react';
import { Provider as Fela } from 'react-fela';
import PropTypes from 'prop-types';

// Enhance Fela provider for universal base components.
export default class FelaProvider extends React.Component {
  static propTypes = {
    Button: PropTypes.func.isRequired,
    Image: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    Text: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    TextInput: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    TextInputMultiLine: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    View: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    mountNode: PropTypes.object,
    renderer: PropTypes.object.isRequired,
  };

  static childContextTypes = {
    Button: PropTypes.func,
    Image: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    Text: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    TextInput: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    TextInputMultiLine: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    View: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    renderer: PropTypes.object
  };

  getChildContext() {
    const { Button, Image, Text, TextInput, TextInputMultiLine, View } = this.props;
    return { Button, Image, Text, TextInput, TextInputMultiLine, View };
  }

  render() {
    const { children, mountNode, renderer } = this.props;
    return (
      <Fela mountNode={mountNode} renderer={renderer} key={Date.now()}>
        {React.Children.only(children)}
      </Fela>
    );
  }
}
